// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__8VrSL","checkboxWrapper":"styles_checkboxWrapper__1NyTB","sidebarItemWrapper":"styles_sidebarItemWrapper__vOP5L"};